var columns = {
    selectors: {
        columns: '[data-match="columns"]'
    },
    init: function() {
    	var self = this;

        $( self.selectors.columns ).matchHeight( {} );
    }
}

export {
    columns
};
